export const CHECKBOX = 'CHECKBOX';
export const RADIO = 'RADIO';
export const SHORT_ANSWER = 'SHORT_ANSWER';
export const LONG_ANSWER = 'LONG_ANSWER';
export const RADIO_GRID = 'RADIO_GRID';
export const CHECKBOX_GRID = 'CHECKBOX_GRID';
export const DROPDOWN = 'DROPDOWN';
export const LINEAR = 'LINEAR';
